export const appConstants = {
  LOADING_STATUS: "LOADING_STATUS",
  SET_USER_INFO: "SET_USER_INFO",
  ADD_TOAST: "ADD_TOAST",
  REMOVE_TOAST: "REMOVE_TOAST",
  API_REQUEST: "API_REQUEST",
};
